// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FaqList_wrapper__8Svq_","altBackground":"FaqList_altBackground__HuZWh","iconContainer":"FaqList_iconContainer__7jd_g","svgIcon":"FaqList_svgIcon__6O6cJ"};